import { makeAxios } from '../redux/thunks/validation';
import { ThunkActionType } from '../redux/actions/types';

// API endpoint configuration
const API_ENDPOINTS = {
    SECURITY_QUESTION: '/save/securityQuestionInfo'
} as const;

/**
 * Represents the result of probing API call
 */
export interface SecurityQuestionResult {
    isSuccessful: boolean;
    errorMessage?: string;
    isLocked?:boolean;
}

/**
 * Represents the request payload for security question
 */
interface SecurityQuestionPayload {
    questionId: number;
    AnswerText: string;
}

/**
 * Validates the input parameters for security question
 * @param question The security question
 * @param answer The user's answer
 * @returns boolean indicating if input is valid
 */
const validateInput = (question: string, answer: string): boolean => {
    if (!question?.trim() || !answer?.trim()) {
        console.warn('Invalid input: question or answer is empty');
        return false;
    }
    return true;
};

/**
 * Posts security question info to the server
 */
export function postSecurityQuestionInfo(
    question: string,
    answer: string
): ThunkActionType<Promise<SecurityQuestionResult>> {
    return async (dispatch, getState) => {
        if (!validateInput(question, answer)) {
            throw new Error('Invalid input: question or answer is empty');
        }

        const payload: SecurityQuestionPayload = {
            questionId: parseInt(question),
            AnswerText: answer.trim(),
        };

        try {

            // Get axios instance
            const makeAxiosAction = makeAxios();
            const axiosInstance = await makeAxiosAction(dispatch, getState, undefined);

            // Make the API call
            const response = await axiosInstance.post<SecurityQuestionResult>(
                API_ENDPOINTS.SECURITY_QUESTION,
                payload
            );


            if (!response?.data) {
                throw new Error('Empty response received from security question service');
            }

            const result = response.data;

            return result;

        } catch (error) {
            console.error('Security question service error:', {
                error,
                question: question.substring(0, 50) + '...',
                hasAnswer: !!answer,
                payload
            });
            throw error;
        }
    };
}